import type { Icon } from '../../../src/lib/types'
export const mdiDockBottom: Icon = {
  "id": "dock-bottom",
  "name": "Dock Bottom",
  "path": "M20 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V6A2 2 0 0 0 20 4M20 13H4V6H20Z",
  "as": [],
  "tags": []
}
export default mdiDockBottom